import { render, staticRenderFns } from "./relaCheck.vue?vue&type=template&id=4b91a112&scoped=true"
import script from "./relaCheck.vue?vue&type=script&lang=js"
export * from "./relaCheck.vue?vue&type=script&lang=js"
import style0 from "./relaCheck.vue?vue&type=style&index=0&id=4b91a112&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b91a112",
  null
  
)

export default component.exports